import styled from 'styled-components'
import { Col } from 'ui-cubic/dist/index.es'

const ColRight = styled(Col)`
 text-align: right;
`

export {
  Row,
  Col
} from 'ui-cubic/dist/index.es'
export { default as RowMargin } from './RowMargin'
export { ColRight }
